import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const TravelLeaders = lazy(() => import("@/pages/agent/portals/travel-leaders/TravelLeaders"));

const Error404 = lazy(() => import("@/pages/Error404"));

const portalsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "travel-leaders",
    element: <TravelLeaders />,
  },
];

export default portalsRoutes;
